// export const initialIntegrationsData = {
//   whatsapp: {
//     title: "WhatsApp",
//     providers: [
//       {
//         name: "Posible",
//       },
//       {
//         name: "Gupshup",
//       },
//       {
//         name: "CPaaS",
//       },
//       // {
//       //   name: "Twilio",
//       // },

//       // {
//       //   name: "AiSensy",
//       // },
//     ],
//   },
//   sms: {
//     title: "SMS Setup",
//     providers: [
//       {
//         name: "Twilio SMS",
//       },
//       {
//         name: "Msg91",
//       },
//     ],
//   },
//   paymentGateway: {
//     title: "EDC machine / POS Terminal",
//     providers: [
//       // {
//       //   name: "Stripe",
//       // },
//       // {
//       //   name: "Razorpay",
//       // },
//       {
//         name: "Phonepe",
//       },
//     ],
//   },
//   email: {
//     title: "Email Setup",
//     providers: [
//       {
//         name: "SendGrid",
//       },
//       {
//         name: "Mailgun",
//       },
//     ],
//   },
// };

export const initialIntegrationsData = {
  whatsapp: {
    title: "WhatsApp",
    providers: [{ name: "Posible" }, { name: "Gupshup" }, { name: "CPaaS" }],
  },

  // sms: {
  //   title: "SMS Setup",
  //   providers: [
  //     { name: "Twilio SMS" },
  //     { name: "Msg91" },
  //   ],
  // },

  paymentGateway: {
    title: "EDC machine / POS Terminal",
    providers: [{ name: "Phonepe" }],
  },

  // email: {
  //   title: "Email Setup",
  //   providers: [
  //     { name: "SendGrid" },
  //     { name: "Mailgun" },
  //   ],
  // },
 logistic: {
    title: "Logistics Integrations",
    providers: [{ name: "shiprocket" }],
  },

  loyalty: {
    title: "Loyalty Program",
    providers: [{ name: "MLoyal" }, { name: "EasyRewardz" }],
  },

  warehouse: {
    title: "Warehouse / Inventory",
    providers: [{ name: "Vinculum" }],
  },

  adsrIntegration: {
    title: "ADSR Integration",
    providers: [{ name: "Pathfinder" }],
  },
};

export function mergeProviderStatus(staticProviders, backendProviders) {
  const backendMap = new Map();

  backendProviders.forEach((p) => {
    if (p && p.hasOwnProperty("provider")) {
      backendMap.set(p.provider.toLowerCase(), p);
    }
  });

  return staticProviders.map((p) => {
    let backendData = null;

    if (
      p &&
      p.hasOwnProperty("name") &&
      backendMap.has(p.name.toLowerCase())
    ) {
      backendData = backendMap.get(p.name.toLowerCase());
    }

    return {
      ...p,
      isSetupDone:
        backendData &&
        backendData.hasOwnProperty("isSetupDone")
          ? backendData.isSetupDone
          : false,

      isActive:
        backendData &&
        backendData.hasOwnProperty("isActive")
          ? backendData.isActive
          : false,

      credentials:
        backendData &&
        backendData.hasOwnProperty("credentials")
          ? backendData.credentials
          : null,

      id:
        backendData &&
        backendData.hasOwnProperty("_id")
          ? backendData._id
          : null,
    };
  });
}

//predefined transactional templates for CPaaS

export const predefinedTransactionalTemplates = [
  // Sales Templates

  // sales invoice done
  {
    templateId: "20600",
    eventName: "sales",
    name: "Invoice Notification",
    category: "Sales",
    defaultContent:
      "Hi {{1}}, Your purchase at {{2}} has been completed successfully.🧾 Bill No: {{3}} 🗓️ Date: {{4}} 📄 Digital Invoice: {{5}} Warm Regards, Team POSible",
    variables: ["1", "2", "3", "4", "5"],
    isSetupDone: false,
    lastUpdated: null,
  },
  //recieve payment done
  {
    templateId: "20733",
    eventName: "receive_payment",
    name: "Payment Received",
    category: "Sales",
    defaultContent:
      "Hi {{1}} , We have recorded your payment for invoice {{2}}  at {{3}} . Amount paid: {{4}} ",
    variables: ["1", "2", "3", "4"],
    isSetupDone: false,
    lastUpdated: null,
  },
  //sales return done
  {
    templateId: "20744",
    eventName: "sales_return",
    name: "Sales Return",
    category: "Sales",
    defaultContent:
      "Hi {{1}},\nYour return request at {{2}} has been processed successfully.\n\n🧾 Return ID: {{3}}\n💰 Refund Amount: {{4}}\n🗓️ Processed On: {{5}}\n📄 View Return Details: {{6}}\n\nTeam POSible",
    variables: ["1", "2", "3", "4", "5", "6"],
    isSetupDone: false,
    lastUpdated: null,
  },

  // Wallet Templates
  //wallet recharge done
  {
    templateId: "20602",
    eventName: "wallet_recharge",
    name: "Wallet Recharge",
    category: "Wallet",
    defaultContent:
      "💰 Dear {{1}},\nYour wallet at {{2}} has been credited with ₹{{3}}. 💳 New Balance: ₹{{4}} 📝 Transaction ID: {{5}} Team POSible",
    variables: ["1", "2", "3", "4", "5"],
    isSetupDone: false,
    lastUpdated: null,
  },

  //wallet redemption done
  {
    templateId: "20989",
    eventName: "wallet_redemption",
    name: "Wallet Redemption",
    category: "Wallet",
    defaultContent:
      "Hi {{1}},\n\n✅ You’ve successfully redeemed {{2}} from your wallet.\n💰 Your new balance is {{3}}.\n🆔 Transaction ID: {{4}}\n\n🏪 Store: {{5}}\n\n🙏 Thank you for using our service!",
    variables: ["1", "2", "3", "4", "5"],
    isSetupDone: false,
    lastUpdated: null,
  },

  // Loyalty Templates
  {
    templateId: "20994",
    eventName: "loyalty_earn",
    name: "Loyalty Points Earned",
    category: "Loyalty",
    defaultContent:
      "🎉 Dear {{1}},\n\nCongratulations! Your loyalty account at {{2}} has been updated.\n\n✨ Points Earned: {{3}}\n📊 Total Points: {{4}}\n\nThank you for being with us!\n— Team POSible",
    variables: ["1", "2", "3", "4"],
    isSetupDone: false,
    lastUpdated: null,
  },
  {
    templateId: "20992",
    eventName: "loyalty_redemption",
    name: "Loyalty Points Redeemed",
    category: "Loyalty",
    defaultContent:
      "🌟 Dear {{1}},\n\nYour loyalty redemption of {{2}} points is successful.\n📊 Remaining Balance: {{3}} points.\n🏪 Store: {{4}}\n\nThank you for your loyalty.",
    variables: ["1", "2", "3", "4"],
    isSetupDone: false,
    lastUpdated: null,
  },
  // otp for all done
  {
    templateId: "20728",
    eventName: "otp",
    name: "otp",
    category: "otp",
    defaultContent:
      "{{1}} is your verification code. For your security, do not share this code.Expires in 5 minutes.",
    variables: ["1"],
    isSetupDone: false,
    lastUpdated: null,
  },

  // Appointment Templates
  {
    templateId: "21137",
    eventName: "new_appointment",
    name: "New Appointment confirmation",
    category: "Appointment",
    defaultContent:
      "👋 Hello {{1}},\n\nYour appointment at {{2}} has been confirmed ✅\n\n📅 Date: {{3}}\n⏰ Time: {{4}}\n💆 Service: {{5}}\n👨‍💼 Professional: {{6}}\n\nWe look forward to seeing you soon!",
    variables: ["1", "2", "3", "4", "5", "6"],
    isSetupDone: false,
    lastUpdated: null,
  },
  {
    templateId: "appointment-reminder",
    eventName: "appointment_reminder",
    name: "Appointment Reminder",
    category: "Appointment",
    defaultContent:
      "Reminder: You have an appointment with {{1}} tomorrow at {{2}}. Please arrive 10 minutes early.",
    variables: ["1", "2"],
    isSetupDone: false,
    lastUpdated: null,
  },
  {
    templateId: "appointment-reschedule",
    eventName: "appointment_reschedule",
    name: "Appointment Reschedule",
    category: "Appointment",
    defaultContent:
      "Hi {{1}}, your appointment with {{2}} has been rescheduled to {{3}} at {{4}}. Reply RESCHEDULE to change.",
    variables: ["1", "2", "3", "4"],
    isSetupDone: false,
    lastUpdated: null,
  },
];

//predefined transactional templates for GupSup

// export const predefinedTransactionalTemplates = [
//   // Sales Templates
//   // sales invoice done
//   {
//     templateId: "e4e15f97-f52f-485a-a1f9-5b005a1df10f",
//     eventName: "sales invoice",
//     name: "Invoice Notification",
//     category: "Sales",
//     defaultContent:
//       "Hi,\n\nThank You For 🛒Shopping With {{store_name}}\n\n✅ Your Purchase on 🗓️ {{transaction_date}} has been Successfully Completed\n\n🧾Bill No : 👉{{transaction_no}}\n\n🧾View Your Digital Invoice: 👉 {{transaction_link}}\n\n💬 Share Your Feedback : 👉 {{feedback_link}}\n\nWarm Regards,\nTeam POSible\nThanks for your Visit. Do Visit Us again.",
//     variables: [
//       "store_name",
//       "transaction_date",
//       "transaction_no",
//       "transaction_link",
//       "feedback_link",
//     ],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // recieve payment
//   {
//     templateId: "20733",
//     eventName: "receive payment",
//     name: "Payment Received",
//     category: "Sales",
//     defaultContent:
//       "Hi {{customer_name}} , We have recorded your payment for invoice {{invoice_number}}  at {{store_name}} . Amount paid: {{amount}} ",
//     variables: ["customer_name", "invoice_number", "store_name", "amount"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   //sales return
//   {
//     templateId: "20744",
//     eventName: "sales_return",
//     name: "Sales Return",
//     category: "Sales",
//     defaultContent:
//       "Hi {{customer_name}},\nYour return request at {{order_id}} has been processed successfully.\n\n🧾 Return ID: {{return_id}}\n💰 Refund Amount: {{amount}}\n🗓️ Processed On: {{processed_on}}\n📄 View Return Details: {{return_details_url}}\n\nTeam POSible",
//     variables: [
//       "customer_name",
//       "return_id",
//       "order_id",
//       "amount",
//       "processed_on",
//       "return_details_url",
//     ],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // Wallet Templates
//   //wallet recharge done
//   {
//     templateId: "2d7ebe8a-1073-4f77-a060-1ca1af7e752a",
//     eventName: "Wallet - Recharge message",
//     name: "Wallet Recharge",
//     category: "Wallet",
//     defaultContent:
//       "💰 Dear {{customer_name}},\n\nYour wallet has been recharged with {{amount}}. 🎉\n\n💳 New Balance: {{new_balance}}\n📝 Transaction ID: {{transaction_no}}\n\nThank you for using our services! 🙌",
//     variables: ["customer_name", "amount", "new_balance", "transaction_no"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },
//   //wallet redemption done
//   {
//     templateId: "e7d53703-6618-4495-a8cd-2a2eea29ce28",
//     eventName: "Wallet - Redemption message",
//     name: "Wallet Redemption",
//     category: "Wallet",
//     defaultContent:
//       "Hi {{customer_name}},\n\n✅ You’ve successfully redeemed {{amount}} from your wallet.\n💰 Your new balance is {{remaining_balance}}.\n🆔 Transaction ID: {{transaction_no}}\n\n🙏 Thank you for using our service!",
//     variables: [
//       "customer_name",
//       "amount",
//       "remaining_balance",
//       "transaction_no",
//     ],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // Loyalty Templates

//   {
//     templateId: "1a670196-2746-4745-89dc-0a580dc48714",
//     eventName: "Loyalty - Earn message",
//     name: "Loyalty Points Earned",
//     category: "Loyalty",
//     defaultContent:
//       "🎉 Congratulations, {{customer_name}}! 🎉\n\nYou've just earned {{loyalty_points_earned}} loyalty points for your recent purchase! 🛍\n\n✨ Your total points: {{loyalty_balance}}\n\nKeep shopping to unlock more rewards!",
//     variables: ["customer_name", "loyalty_points_earned", "loyalty_balance"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // loyaly redeemed done
//   {
//     templateId: "acf2ec73-b151-40a8-8b94-7d34b5380ac3",
//     eventName: "Loyalty - Burn/Redemption message",
//     name: "Loyalty Points Redeemed",
//     category: "Loyalty",
//     defaultContent:
//       "🌟 Dear {{customer_name}},\n\nYour loyalty redemption of {{loyalty_points_redeemed}} points is successful.\n📊 Remaining Balance: {{loyalty_balance}} points.\n\nWe appreciate your loyalty! ✨",
//     variables: ["customer_name", "loyalty_points_redeemed", "loyalty_balance"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // otp for all done
//   {
//     templateId: "684f36f2-ac5a-441c-a7c8-b95c8d461731",
//     eventName: "otp",
//     name: "otp",
//     category: "otp",
//     defaultContent:
//       "{{otp}} is your verification code. For your security, do not share this code. Expires in 5 minutes.",
//     variables: ["otp"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },

//   // Appointment Templates
//   {
//     templateId: "337f3b30-7595-4a0e-9511-36ea21c8367f",
//     eventName: "New appointment",
//     name: "New Appointment confirmation",
//     category: "Appointment",
//     defaultContent:
//       "👋 Hello {{customer_name}},\n\nYour appointment at {{store_name}} has been confirmed ✅\n\n📅 Date: {{date}}\n⏰ Time: {{time}}\n💆 Service: {{service_name}}\n👨‍💼 Professional: {{staff_name}}\n📍 Location: {{location}}\n\nWe look forward to seeing you soon!",
//     variables: [
//       "customer_name",
//       "store_name",
//       "date",
//       "time",
//       "service_name",
//       "staff_name",
//       "location",
//     ],
//     isSetupDone: false,
//     lastUpdated: null,
//   },
//   {
//     templateId: "appointment-reminder",
//     eventName: "Appointment Reminder",
//     name: "Appointment Reminder",
//     category: "Appointment",
//     defaultContent:
//       "Reminder: You have an appointment with {{business_name}} tomorrow at {{time}}. Please arrive 10 minutes early.",
//     variables: ["business_name", "time"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },
//   {
//     templateId: "appointment-reschedule",
//     eventName: "Appointment Reschedule",
//     name: "Appointment Reschedule",
//     category: "Appointment",
//     defaultContent:
//       "Hi {{customer_name}}, your appointment with {{business_name}} has been rescheduled to {{new_date}} at {{new_time}}. Reply RESCHEDULE to change.",
//     variables: ["customer_name", "business_name", "new_date", "new_time"],
//     isSetupDone: false,
//     lastUpdated: null,
//   },
// ];

// variableMap.js

export const variableMap = {
  Sales: [
    { label: "Transaction No", value: "transaction_no" },
    { label: "Transaction Date", value: "transaction_date" },
    { label: "Customer First Name", value: "first_name" },
    { label: "Customer Last Name", value: "last_name" },
    { label: "Customer Name", value: "customer_name" },
    { label: "Store Name", value: "store_name" },
    { label: "Store Phone No", value: "store_phone" },
    { label: "Store Email ID", value: "store_email" },
    { label: "Transaction Amount", value: "transaction_amount" },
    { label: "Paid Amount", value: "paid_amount" },
    { label: "Balance Amount", value: "balance_amount" },
    { label: "Transaction Link", value: "transaction_link" },
  ],

  ProductAlert: [
    { label: "Customer Name", value: "customer_name" },
    { label: "Product Name", value: "product_name" },
    { label: "Store Name", value: "store_name" },
  ],

  Membership: [
    { label: "Membership Name", value: "membership_name" },
    { label: "Customer Name", value: "customer_name" },
    { label: "Membership Expiry Date", value: "membership_expiry_date" },
    { label: "Store Name", value: "store_name" },
  ],

  Package: [
    { label: "Package Name", value: "package_name" },
    { label: "Customer Name", value: "customer_name" },
    { label: "Package Expiry Date", value: "package_expiry_date" },
    { label: "Store Name", value: "store_name" },
  ],

  OTP: [{ label: "OTP", value: "otp" }],
  "Online Store": [{ label: "OTP", value: "otp" }],

  Wallet: {
    "wallet_recharge": [
      { label: "Customer Name", value: "customer_name" },
      { label: "Transaction No", value: "transaction_no" },
      { label: "Transaction Date", value: "transaction_date" },
      { label: "Recharge Amount", value: "recharge_amount" },
      { label: "Wallet Balance", value: "wallet_balance" },
      { label: "Store Name", value: "store_name" },
    ],
    "wallet_redemption": [
      { label: "Customer Name", value: "customer_name" },
      { label: "Transaction No", value: "transaction_no" },
      { label: "Transaction Date", value: "transaction_date" },
      { label: "Redemption Amount", value: "redemption_amount" },
      { label: "Wallet Balance", value: "wallet_balance" },
      { label: "Store Name", value: "store_name" },
    ],
    "Wallet - Redemption OTP": [{ label: "OTP", value: "otp" }],
  },

  Loyalty: {
    "loyalty_earn": [
      { label: "Customer Name", value: "customer_name" },
      { label: "Transaction No", value: "transaction_no" },
      { label: "Transaction Date", value: "transaction_date" },
      { label: "Loyalty Points Earned", value: "loyalty_points_earned" },
      { label: "Total Loyalty Points", value: "loyalty_balance" },
      { label: "Store Name", value: "store_name" },
    ],
    "loyalty_redemption": [
      { label: "Customer Name", value: "customer_name" },
      { label: "Transaction No", value: "transaction_no" },
      { label: "Transaction Date", value: "transaction_date" },
      { label: "Loyalty Points Redeemed", value: "loyalty_points_redeemed" },
      { label: "Total Loyalty Points", value: "loyalty_balance" },
      { label: "Store Name", value: "store_name" },
    ],
    "Loyalty - Redemption OTP": [{ label: "OTP", value: "otp" }],
  },
};

export const promotionalVariable = [
  { label: "Customer Name", value: "customerName" },        // ✅ Maps to raw.customer.name
  { label: "Offer Name", value: "offerName" },              // ✅ Maps to raw.offer?.name
  { label: "Store Name", value: "storeName" },              // ✅ Maps to raw.store?.label
  { label: "Store Phone", value: "storePhoneNo" },          // ✅ Maps to raw?.store?.phoneNo
  { label: "Store Email", value: "storeEmailId" },          // ✅ Maps to raw?.store?.emailId
  { label: "Store Pincode", value: "storePincode" },        // ✅ Maps to raw?.store?.pincode
  { label: "Store Country", value: "storeCountry" },        // ✅ Maps to raw?.store?.country
  { label: "Store City", value: "storeCity" },              // ✅ Maps to raw?.store?.city
  { label: "Store State", value: "storeState" },            // ✅ Maps to raw?.store?.state
  { label: "Store Address Line 1", value: "storeAddress1" }, // ✅ Maps to raw?.store?.address1
  { label: "Store Address Line 2", value: "storeAddress2" }, // ✅ Maps to raw?.store?.address2
];

let allVars = [];

Object.values(variableMap).forEach((category) => {
  if (Array.isArray(category)) {
    allVars.push(...category);
  } else {
    Object.values(category).forEach((sub) => {
      allVars.push(...sub);
    });
  }
});

export const allTransactionalVariables = [
  ...new Set(allVars.map((v) => JSON.stringify(v))),
].map((v) => JSON.parse(v));
